export default {
  applyChangesButton: 'Änderungen anwenden',
  buttonJumpToStart: 'Zum Start springen',
  buttonRewind: '{0} Schritte ({1}) zurück',
  buttonPlay: 'Start',
  buttonPause: 'Pause',
  buttonFastForward: '{0} Schritte ({1}) vorwärts',
  buttonJumpToEnd: 'Zum Ende springen',
  buttonNextStep: 'Nächste Rezeptschritt',
  buttonPrevStep: 'Vorherige Rezeptschritt',
};
